'use strict';
	(function(fox, $) {
	// const UA_PARSER = require('ua-parser-js');

	// var _ = {
	// 	getTranslation: function(alias) {
	// 		var translation = {
	// 			'emailNotValid': function() {return fox.i18n.getTranslation('emailNotValid', 'Email is not valid', 'tooltip');},
	// 			'fieldIsRequired': function() {return fox.i18n.getTranslation('fieldNotEmpty', 'Fields shouldn\'t be empty', 'tooltip');}
	// 		};

	// 		return translation[alias] || '';
	// 	}
	// };

	fox.registerWidget('CCPR_Form', {
		configure() {

			this.registerOptions('', {
				template: 'page_ccpa_login_form',
				widgets:{
					snManager: {
						widget: 'Widget',
						autoRender: false,
						active: false
					},
					authApi: {
						widget: 'Api',
						method: 'ccpa.request',
						httpMethod: 'post',
						
					},
					form: {
						widget: 'DomForm',
						formSelector: '#ccpa-form',

					},
				},
				handleWom: {
					formInvaliadate: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: this._handleFormValidation.bind(this)
					}
				},
				handleDom: {
					onFocus: {
						target: '[name="email"]',
						event: 'focus',
						callback: '_clearErrors'
					},

					formButtonSubmit: {
						target: '#ccpa-form',
						event: 'submit',
						callback: '_submit' 
					},
					closePopup: {
						event: 'click',
						target: '.cancel-close',
						callback: 'closePopup'
					}
				}
			});
			
			this.callParent('configure', arguments);
		},

		running() {
			this.callParent('running', arguments);

			this.notices = fox.wom.selectFirst('~#throughNotifications');
		},
		activate() {
			this.form = this.rwom1('#form');
			
			this.checkMember();
			this.callParent('activate', arguments);
		},

		rendering() {
			this.callParent('rendering', arguments);

			this.errorBox = $(this.dom('#errors'));
			this.errorsContainer = $(this.dom('#errors .txt'));
		},

		checkMember() {
			if (fox.isEmpty(fox.site.member)) {
				this.form.setOption('elements.email', {
					//validateOnFly: true,
					// type: 'input',
					validators: [
						{validator: 'mandatory', message: this.getTextMessage('fieldIsRequired')},
						{validator: 'regexp', options: {type: 'email'}, message: this.getTextMessage('emailNotValid')}
					]
				});
				this.setTemplateOptions('member', false);
				this.isMember = false;

				return;
			}

			this.setTemplateOptions('member', true);
			this.isMember = true;
		},
		formSubmitError(err) {
			//this.showErrorMessage(err.answer.reason);
			//this.togglePreloader(false);
			
			this.notices.pushNotification({
				noticeTemplate: 'new_notice',
				noticeType: 'error',
				noticeMessage: 'Oops! There is no such user in our system',
				//noticeAlias: 'loginError',
				delayClose: 3000
			});

			this.togglePreloader(false);
		},

		getTextMessage(alias) {
			let msg = '';

			switch (alias) {
				case 'emailNotValid':
					msg = 'Email is not valid';
					break;
				case 'fieldIsRequired':
					msg = 'This field is required';
					break;
			}

			return msg;
		},

		showErrorMessage(msg, fieldName) {
			//console.log(msg, fieldName)
			const $elm = $(this.dom1(`[name="${fieldName}"]`));

			$elm.addClass('error');
			$elm.parent().find('._error-text').text(msg);
		},
		_submit(el, w, alias, e) {

			fox.jQuery.Event(e).preventDefault();

			this.wom1('#form').submit().then(result => {
				if (result === false) {
					return;
				}

				this.togglePreloader(true);

				this.submit().then(resp => {
					var response = resp.params.answer.response;

					this.togglePreloader(false);

					this.onSuccessSubmit();

				})
				.catch(err => {
					const answer = err.params.answer;

					switch(answer.code) {
						default:
							this.showErrorMessage('Oops! There is no such user in our system', 'email');
					}
					this.togglePreloader(false);
				
				});
			});
		},

		submit() {
			var data = this.wom1('#form').getValues();

			Object.keys(data).forEach(key => {
				data[key] = window.encodeURIComponent(data[key]);
			});

			return this.wom1('#authApi').psend(data);
			
		},
	
		togglePreloader(state) {
			var btn = this.dom1('#form-submit');

			if (!btn) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', btn);
		},
		_handleFormValidation(formData, form) {
			var msg = '';

			formData.forEach(resp => {
				var $elm = $(this.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					this.showErrorMessage(resp.message, resp.field);
					$elm.addClass('error');

					return;
				}

				$elm.removeClass('error');

			});
		},

		onSuccessSubmit() {
			const values = {...this.form.getValues()};

			var w = this.wom1('@parent @parent #popupSuccess #content');
			values.optionAlias === 'deleteInformation'? w.setTemplateOptions('deleteInformation', true) : w.setTemplateOptions('deleteInformation', false) 
			w.render();
			this.resetForm();
			this.dispatchEvent('form_submit_success', values);
		},

		_clearErrors(elm) {
			var $elm = $(elm);
			var $p = $elm.parent();

			$elm.removeClass('error'); 
			$p.removeClass('error');

			$p.find('._error-text').text('');
		},

		resetForm() {
			const values = {
				optionAlias: 'knowInformation',
				comment: '',
			};

			if (!this.member) {
				values.email = '';
			}
		
			this.form.setValues(values);
		},

		getSuccessMessage(values) {
			if (values.optionAlias === 'deleteInformation') {
				return 'Thank you! Your request has been submitted. An account manager will contact you to confirm and finalize it.'
			}
			return 'Thank you! Your request has been submitted. The response will be sent to your email.';
		},
		closePopup(){
			this.getParent().hide()
		}

	}, 'Widget');
})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/CCPA/widget/form.es.js